import { forwardDetail } from '@/api/forward'

const state = {
  visible: false, // 显示加价弹窗

  goods_detail: {}, // 商品数据
  share_options: {} // 分享数据
}

const mutations = {
  TOGGLE(state, flag) {
    state.visible = flag
  },
  SET_DATA(state, data) {
    for (const key in data) {
      state[key] = data[key]
    }
  },
  SET_GOODS_DETAIL(state, data) {
    state.goods_detail = data
  },
  SET_SHARE_OPTIONS(state, data) {
    state.share_options = data
  }
}

const actions = {
  // 显示加价弹窗
  show({ dispatch, commit }, data = { params, shareOptions }) {
    dispatch('app/showLoading', {}, { root: true })
    forwardDetail({ ...data.params, forwardType: 'GOODS' })
      .then(res => {
        dispatch('app/hideLoading', {}, { root: true })
        commit('SET_GOODS_DETAIL', { ...data.params, ...res.data })
        commit('SET_SHARE_OPTIONS', data.shareOptions)
        console.log('dsdsds')
        
        commit('TOGGLE', true)
      })
      .catch(() => {
        dispatch('app/hideLoading', {}, { root: true })
      })

  },
  // 隐藏加价弹窗
  hide({ commit }) {
    commit('TOGGLE', false)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}